import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../assets/styles/themes/tokens';
import useRouter from '../../utils/useRouter';

interface DashboardPageHeaderProps {
  firstName?: string;
}

const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({ firstName }) => {
  const { t } = useTranslation();
  const { match: { location: { query } } } = useRouter();
  const isFirstLogin = query?.isOnboardingComplete === 'true';

  const getWelcomeMessage = (isOnboardingComplete: boolean, firstName: string | undefined) => {
    const message = isOnboardingComplete ? t('Welcome') : t('Welcome back');
    return firstName ? `${message}, ${firstName}` : message;
  };
  
  return (
    <Typography 
      variant='h5' 
      sx={{ color: palette.text.primary }}>
      {getWelcomeMessage(isFirstLogin, firstName)}
    </Typography>
  );
};

export default DashboardPageHeader;
